

angular.module("cmsArticles")

    .controller("CmsArticlesListCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CMS_CATEGORIES_WRITE");
        $rootScope.title = $filter('translate')('cms_articles.title');

        $rootScope.breadcrumb = [
            { title: $filter('translate')('cms_articles.title') }
        ];

        $scope.filter = {};
        let filter = false;

        $scope.gridArticles = {
            pdfTitle: $filter('translate')('cms_categories.articles'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            }, 
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'icon', displayName: $filter('translate')('cms.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                        '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                        '</div>', width: 80, enableFiltering: false, enableHiding: false
                },
                {
                    name: 'title', displayName: $filter('translate')('cms_article.title'), enableFiltering: true, enableHiding: false, width: 150
                },
                {
                    name: 'FK_cms_articles_cms_categories.name', displayName: $filter('translate')('cms_article.category'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ui-sref="cms_articles.edit({id:row.entity.id, parent_id:row.entity.cms_category_id, standalone: true})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteArticleDialog(row.entity.id,row.entity.title);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {

                var deferred = $q.defer();
                options.full = true;

                if (filter) {
                    options.title = $scope.filter.title;
                    options.category = $scope.filter.category;
                }

                Restangular.all('CmsArticles').getList(options).then(function (results) {
                    deferred.resolve(results);
                });
                return deferred.promise;
            }
        };


        $scope.search = function () {
            if (angular.isDefined($scope.gridArticles.loadData)) {
                filter = true;
                $scope.gridArticles.loadData(false);
            }
        }

        $scope.deleteArticleDialog = function (id, title) {
            $scope.id = id;
            $scope.name = title;
            modalService.confirm({
                title: $filter('translate')('cms_articles.delete'),
                message: $filter('translate')('cms_articles.delete_message') + " " + title + "?",
                onAccept: function () {
                    Restangular.one('CmsArticles', id).remove().then(function () {
                        toastr.success($filter('translate')('cms_articles.remove_success'));
                        $scope.gridArticles.loadData(false);
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                    });
                }
            });

        };

    }])

    ;

